import React from 'react'
import { Image, Transformation } from 'cloudinary-react'

const StudentLogo = (props) => {
    const { className, width, height } = props

    return (
        <Image
            className={className}
            cloudName='studentbe'
            publicId='student-be-logos/Student_2024_Logo_Main.png'
            alt='Student.be logo'
        >
            <Transformation
                flags='progressive'
                fetchFormat='auto'
                crop='limit'
                quality='auto:best'
                width={width || 300}
                height={height}
            />
        </Image>
    )
}

export default StudentLogo
